import { useEffect } from 'react'

export const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return
      }
      handler(event)
    }
    document.addEventListener('mousedown', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
    }
  }, [ref, handler])
}

export { useCookieBanner } from './useCookieBanner'
export { useTracking } from './useTracking'
export { useGameState } from './useGameState'
export { useCardPool } from './useCardPool'
export { useCardAnimation } from './useCardAnimation'
export { useHubspotScript } from './useHubspotScript'
